export default __webpack_public_path__ + "static/media/featureImage1.3df4ee29.png";